module.exports = __webpack_public_path__ + "img/chat.f14b1668.svg";